<template>
  <div>
    <el-dialog
      :visible="dialogVisible"
      width="80%"
      class="detail-dialog"
      @close="closeDialog"
      @open="openDialog"
    >
      <div slot="title" class="header-title">
        查看分批发货
        <span v-if="infoData.deliveryNum">({{ infoData.deliveryNum || '' }})</span>
      </div>
      <p>产品信息</p>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%;margin-top:10px;margin-bottom:10px"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="itemIndex" width="80" label="序号" align="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" width="70" />
        <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" width="120" header-align="left" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="right" width="120" header-align="left" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="150" />
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="150" />
      </el-table>

      <div class="advanceMakeDeatail">
        <div class="baseInfoForm">
          <h3>原信息</h3>
          <div class="rj-row">
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收货地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoData.primaryReceiptAddress }}
                </div>
              </div>
            </div>
          </div>

          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运输方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoData.primaryModelOfShipping }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  承运商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoData.primaryCarrier }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3>变更后信息</h3>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后收货地址：
            </div>
            <div class="rj-baseinfo__item">
              <span>{{ infoData.address }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后运输方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.modeOfShipping }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              变更后承运商：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.carrier }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运费差价：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.freight }}元
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              运费支付方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.freightPayTypeStr }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              价外费用合同号：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.freightContractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              价外费用合同分配金额/比例：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.freightProportion }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              唛头单号：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.marksNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收货回执及到货验收要求：
            </div>
            <div class="rj-baseinfo__item">
              {{ infoData.receiptArrivalAcceptanceRequirements }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <p>发货备注说明：{{ infoData.deliverRemark }}</p>
        </div>
      </div>

      <div class="rj-row flex">
        <span>回执附件：</span>
        <div v-if="fileList.length" class="file-style">
          <ul>
            <li v-for="(item, index) in fileList" :key="index">
              <el-link
                :underline="false"
                style="color:#409EFF"
                @click="fileClick(item)"
              >
                {{ item.fileName }}
              </el-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <p>备注：{{ infoData.remark }}</p>
        </div>
      </div>

      <h3>变更后信息</h3>
      <el-table :data="tableDataHistory" border style="width: 100%;margin-top:10px;margin-bottom:10px">
        <el-table-column prop="approveUserInfo" label="审批人" align="left" width="170" />
        <el-table-column prop="approveComment" label="审批内容" align="left" />
        <el-table-column prop="approveTime" label="审批时间" align="left" />
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="closeDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script type="es6">
import {
  partialInvoiceDetail,
  getApproveLogByPartialId,
  getReceiptAttachmentByPartialShipmentNum,
  attachmentGetToken
} from '@/API';
import { MathAdd } from '@/libs/util';

export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: () => {
        return 0;
      }
    }
  },

  data () {
    return {
      infoData: {}, // 详情数据
      tableData: [], // 产品信息
      tableDataHistory: [], // 产品审批信息
      dialogVisible: this.dialogFormVisible,
      loading: false,
      fileList: [],
      downFileUrl: '',
      token: '',
      uploadUrl: '',
      fileserveDownUrl: ''
    };
  },

  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },

  methods: {
    initData () {
      // 获取详情数据接口
      partialInvoiceDetail({ id: this.id }).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.productList;
          this.infoData = {
            ...data,
            address: `${data.receiptAddress.receiverName || ''}
            ${data.receiptAddress.province || ''}
            ${data.receiptAddress.city || ''}
            ${data.receiptAddress.county || ''}
            ${data.receiptAddress.receiptAddress || ''}
            ${data.receiptAddress.receiverPhone || ''}`
          };
          console.log(this.infoData, 'this.infoData');
          this.initFileData(data.deliveryNum);
        }
      });

      // 获取历史审批意见
      getApproveLogByPartialId({ partialId: this.id }).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.tableDataHistory = data || [];
        }
      });
    },

    // 获取回执附件
    initFileData (val) {
      getReceiptAttachmentByPartialShipmentNum({
        partialShipmentNum: val
      }).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.fileList = data;
        }
      });
    },

    // 下载附件
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    // 文件服务器地址
    initToken () {
      attachmentGetToken().then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.token = data.token;
          this.uploadUrl = data.uploadUrl;
          this.downFileUrl = data.downloadUrl;
        }
      });
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },

    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },

    openDialog () {
      this.initData();
      this.initToken();
    },

    closeDialog () {
      this.infoData = {};
      this.tableData = [];
      this.fileList = [];
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-dialog {
  .flex{
    display: flex;
  }
  .header-title > span {
    color: red;
    margin-left: 10px;
  }
  p{
    margin: 10px 0 ;
  }
  span{
    display:inline-block;
    margin-right: 10px;
  }
  .file-style {
    ul {
      width: 100%;
      list-style: none;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #3f9ef5;
        line-height: 22px;
        cursor: pointer;
      }
    }
  }
}
</style>
